import {APIRequest} from "./APIRequest.js";
export async function openNotification(nid, open = true) {
	var request = new APIRequest();
	request.set('getNotification', 'id', nid);
	var data = (await request.send()).getNotification.data;

	console.log(data);
	
	if (data.view) {
		var url = "";
		switch (data.view) {
			case "dashboard":
				url = "dashboard.php";
				break;
			case "profile":
				url = "profile.php";
				break;
			case "egroup":
				url = "egroup.php";
				if (data.view_params) {
					url += "?"
					var params = JSON.parse(data.view_params);
					if (params['gid'] || params) {
						url += "gid=" + params['gid'];
						if (params['tid']) {
							url += "&pid=" + params['tid'];
						}
					}
				}
				break;
			case "group":
				url = "group.php";
				if (data.view_params) {
					url += "?"
					var params = JSON.parse(data.view_params);
					let gid = params['group-id'] || params['gid'] || null;
					let pid = params['post-id'] || params['pid'] || params['tid'] || null;
					let cid = params['comment-id'] || params['cid'] || null;
					if (gid) {
						url += "gid=" + gid;
						if (pid) {
							url += "&pid=" + pid;
							if (cid) {
								url += "&cid=" + cid;
							}
						}
					}
				}
				break;
			case "bug":
				url = "to_do_list.php";
				break;
		}
		if (url && open) {
			location.href = url;
			return;
		}
	}
}